import { Theme } from '@material-ui/core';
import { ColorDynamic, VisibilityObserver } from '@superdispatch/ui';
import { ReactNode } from 'react';
import { NAVIGATION_BOTTOM_BAR_HEIGHT_CSS_VAR } from 'shared/layout/NavigationHeaderBannerHeight';
import styled, { css } from 'styled-components';

const Wrapper = styled.div(
  ({ theme }: { theme: Theme }) => css`
    &[data-intersecting='false'] {
      left: 0;
      right: 0;
      /* Clear the fixed bottom bar in the responsive web; the var resolves to
         0px in the mobile apps, where no bar renders. */
      bottom: var(${NAVIGATION_BOTTOM_BAR_HEIGHT_CSS_VAR}, 0px);
      padding: 16px;
      position: fixed;
      z-index: ${theme.zIndex.modal};
      background-color: ${ColorDynamic.White};
    }
  `,
);

export function StickyAction({ children }: { children: ReactNode }) {
  return (
    <VisibilityObserver
      render={({ ref, visibility }) => (
        <div ref={ref}>
          <Wrapper data-intersecting={visibility === 'visible'}>
            {children}
          </Wrapper>
        </div>
      )}
    />
  );
}
